import { ActorType, IActor, ICheck } from '@models';

export const checkToActor = (check: ICheck) => check.actor;
export const checkByActorType = (actorType: ActorType) => (check: ICheck) => check.actor?.type === actorType;
export const actorByActorType = (actorType: ActorType) => (actor: IActor) => actor?.type === actorType;
